import Icon from '../../components/Icon.vue'

Icon.register({"brands/bitbucket":{"width":512,"height":512,"paths":[{"d":"M23.1 32C14.2 31.9 7 38.9 6.9 47.8 6.9 48.7 7 49.6 7.1 50.6L74.9 462C76.6 472.4 85.6 480 96.1 480.1H421.2C429.1 480.2 435.9 474.5 437.2 466.7L505 50.7C506.4 42 500.5 33.8 491.8 32.4 490.9 32.3 490 32.2 489 32.2L23.1 32zM308.4 329.3H204.6L176.5 182.5H333.5L308.4 329.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-awesome@3.0.0@vue-awesome/icons/brands/bitbucket.js
// module id = null
// module chunks = 